module.exports = __webpack_public_path__ + "img/locker.57df0f49.svg";